(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Geodata', Geodata);

    Geodata.$inject = ['$resource'];

    function Geodata ($resource) {
        var resourceUrl =  'api/geodata/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
